import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-[fadeIn_0.2s_ease-out]" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-116">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-117">
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100" data-id="element-118">
          <h2 id="legal-modal-title" className="font-serif text-2xl font-bold text-primary" data-id="element-119">
            {title}
          </h2>
          <button onClick={onClose} className="w-9 h-9 rounded-full flex items-center justify-center text-gray hover:bg-light-navy hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30" aria-label="Cerrar" data-id="element-120">
            <X className="w-5 h-5" data-id="element-121" />
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-6 text-text leading-relaxed space-y-4 text-[15px]" data-id="element-122">
          {children}
        </div>
      </div>
    </div>;
}